/**
 * BITTE UI
 * v1.1.2
 */

var bitte = bitte || {};
bitte.ui = bitte.ui || {};

// ==================================================
// Bitte Utility Functions.
// ==================================================

/**
 * Create a random v4 GUID.
 * See http://stackoverflow.com/a/2117523
 * @returns A GUID string prefixed with 'b-' for use as an html ID.
 */
bitte.generateID = function () {
	// Prefix with a 'b' for valid IDs
	return 'b-' + 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0,
		v = c == 'x' ? r : r & 0x3 | 0x8;
		return v.toString(16);
	});
};

/**
 * Sets up the unified wrapper around an inner Bitte input.
 * @param field The field to wrap.
 */
bitte.ui.wrap = function (field) {
	if (field.id) {
		var id = ' id="' + field.id + '"';
	} else {
		var id = '';
	}

	var wrap = $('<div' + id + ' class="bitte-field bitte-ui-' + field.type + ' ' + field.bonusclass + '"></div>');
	var label = $('<label class="bitte-label" id="' + field.labelId + '"></label>');

	if (field.label) {
		label.append($('<span class="label" aria-label="' + field.label + '">' + field.label + '</span>'));
	}

	if (field.required) {
		label.append(' ');
		label.append($('<span class="required-indicator">' + field.requiredText + '</span>'));
	}

	if (field.instructions) {
		label.append(' ');
		label.append($('<span class="instructions">' + field.instructions + '</span>'));
	}

	wrap.append(label);
	wrap.append($('<div class="bitte-message" tabindex="0" role="status"></div>'));
	wrap.append(field.el);
	return wrap;
};

// ==================================================
// Bitte Global Functions.
// ==================================================

/**
 * Generalized Fetch function to grab value from any UI component's underlying fetch().
 * @param el The base UI element.
 * @returns The value of the element, or undefined if an element wasn't found.
 */
bitte.ui.fetch = function (el) {
	el = $(el);
	var type = el.data('type') || false;
	if (type) {
		return bitte.ui[type].fetch(el);
	}
};

// Extend fetch() to a generalized jQuery object.
$.fn.fetch = function () {
	return bitte.ui.fetch(this);
};

/**
 * Fetches a set of all data representing every bitte field within the targeted element.
 */
$.fn.fetchForm = function () {
	var data = {};
	$(this).find('.bitte-field').each(function () {
		var result = $(this).fetch();
		if (result) {
			data[result['name']] = result['value'];
		}
	});
	return data;
};

/**
 * Generalized setValue function to set a value to any UI component's underling setValue().
 * @param el The base UI element.
 * @param value The value to set.
 */
bitte.ui.setValue = function (el, value) {
	el = $(el);
	var type = el.data('type') || false;
	if (type) {
		bitte.ui[type].setValue(el, value);
	}
};

// Extend setValue() to a generalized jQuery object.
$.fn.setValue = function (value) {
	bitte.ui.setValue(this, value);
};

/**
 * Generalized reset function to reset any UI component.
 * @param el The base UI element.
 */
bitte.ui.reset = function (el) {
	el = $(el);
	var type = el.data('type') || false;
	if (type) {
		bitte.ui[type].reset(el);
	}
};

// Extend reset to a generalized jQuery object.
$.fn.reset = function () {
	bitte.ui.reset(this);
};

/**
 * Performs validation on a UI component.
 * @param el The base UI element.
 * @param updatemessage Whether or not to update/add a message if invalid.
 * @returns True if the element has valid input, false if not.
 */
bitte.ui.validate = function (el, updatemessage) {
	el = $(el);
	var validator = el.data('validator');
	if (!validator) {
		return undefined;
	}
	var message = validator(el.fetch()['value']); // Retrieve validation message.
	if (message !== true) {
		if (updatemessage) {
			el.addClass('invalid'); // Mark as invalid.
			el.find('> .bitte-message').text(message); // Show the message.
		}
		return false;
	} else {
		if (updatemessage) {
			el.removeClass('invalid'); // Remove invalid mark.
			el.find('> .bitte-message').text(''); // Clear the message.
		}
		return true;
	}
};

/**
 * Determines if the value of the UI element is valid, but does not update the message.
 */
$.fn.isValid = function () {
	return bitte.ui.validate(this, false);
};

/**
 * Validates the UI element, updating the message.
 */
$.fn.validate = function () {
	return bitte.ui.validate(this, true);
};


/**
 * Validates the whole form, returns true if all fields validate.
 */
$.fn.validateForm = function () {
	var data = true;
	$(this).find('.bitte-field').each(function () {
		var result = $(this).validate();
		if (!result) {
			data = false;
		}
	});
	return data;
};







/**
 * Toggles the enabled status on a given UI element.
 * @param el The base UI element.
 * @param enabled True to enable the element, false to disable it.
 */
bitte.ui.setEnabled = function (el, enabled) {
	el = $(el);
	var type = el.data('type') || false;
	if (type) {
		bitte.ui[type].setEnabled(el, enabled);
	}
};

// Extend setEnabled() to a generalized jQuery object.
$.fn.setEnabled = function (value) {
	bitte.ui.setEnabled(this, value);
};

/**
 * An alternative jQuery shorthand version of the standard Bitte element creation functions.
 * @param inputtype The type of UI object to create.
 * @param params The creation parameters to pass to the creation function.
 */
$.fn.uiCreate = function (inputtype, params) {
	bitte.ui[inputtype].create(params, this);
}

// ==================================================
// Individual Inputs.
// ==================================================

// ----- Uberselect -----

/**
 * The core uberselect object.
 */
bitte.ui.uberselect = bitte.ui.uberselect || {};

/**
 * Creates a new uberselect element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.uberselect.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'uberselect';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['placeholder'] = data['placeholder'] || '';
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.uberselect.validator(data['required'], data['messages']);


	// Check if required.
	var label;
	if (data['required']) {
		// Since we can't add a required attr on `.uberselect-button`
		// we have to add text to the label
		label = data['label'] + ', required';
	} else {
		label = data['label'];
	}

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	var listboxId = bitte.generateID();
	var dropdownContainerId = bitte.generateID();
	var uberselect = $('<div class="uberselect"></div>');
	var button = $('<button class="uberselect-button" type="button" role="button" aria-controls="' + dropdownContainerId + '" aria-haspopup="true" aria-expanded="false" data-label="' + label + '" aria-label="' + label + '"></button>');
	var buttonWrapper = $('<div class="button-wrapper" tabindex="-1"></div>');
	var placeholder = $('<div class="placeholder">' + data['placeholder'] + '</div>');
	buttonWrapper.append(placeholder);
	uberselect.append(button);
	uberselect.append(buttonWrapper);
	var dropdownContainer = $('<div class="dropdown-container" id="' + dropdownContainerId + '" role="combobox" aria-expanded="false" aria-owns="' + listboxId + '" aria-labelledby="' + data['labelId'] + '"></div>');
	var inputContainer = $('<div class="input-container"></div>');
	var searchPlaceholder = data['messages'].searchPlaceholder || 'Search...';
	var input = $('<input class="input focusable" type="text" aria-autocomplete="list" aria-controls="' + listboxId + '" placeholder="' + searchPlaceholder + '"aria-labelledby="' + data['labelId'] + '">');
	inputContainer.append(input);
	dropdownContainer.append(inputContainer);
	var listbox = $('<ul class="listbox" role="listbox" id="' + listboxId + '"></ul>');
	uberselect.append(dropdownContainer);

	// Check if disabled
	if (data['disabled']) {
		button.prop('disabled', 'true');
	}

	// Create options.
	var option;
	for (var i = 0; i < data['options'].length; i++) {
		var value = data['options'][i].value;
		var display = data['options'][i].display;
		option = $('<li><button type="button" class="option match focusable" role="checkbox" aria-checked="false" tabindex="-1" data-value="' + value + '">' + display + '</button></li>');
		listbox.append(option);
	}

	// Create no results text
	var noResultsMessage = data['messages'].noResults || 'No results found.'
	var noResults = $('<li><div class="no-results">' + noResultsMessage + '</div></li>');
	listbox.append(noResults);

	dropdownContainer.append(listbox);

	field.append(uberselect);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'uberselect');
	field.data('name', data['name']);
	field.data('validator', data['validate']);
	field.data('placeholder', data['placeholder']);

	// Bind functionality to element.
	bitte.ui.uberselect.bind(field, data['id']);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a uberselect.
 */
bitte.ui.uberselect.validator = function (required, messages) {
	return function (value) {
		if (required && !value) {
			return messages['nullValue'] || 'Please enter a value.';
		} else {
			return true;
		}
	};
};

/**
 * Retrieves the selected item from the uberselect.
 * @param el The uberselect to retrieve the value from.
 */
bitte.ui.uberselect.fetch = function (el) {
	var values = [];
	var selections = el.find('.option.checked');
	selections.each(function() {
		values.push($(this).attr('data-value'));
	});
	return {
		'name' : el.data('name'),
		'value' : values
	};
};

/**
 * Sets a value for the uberselect.
 * @param el The uberselect field.
 * @param value The value to set.
 */
bitte.ui.uberselect.setValue = function (el, value) {
	el = $(el);

	// Remove options
	var options = el.find('.option');
	options.removeClass('checked');
	options.attr('aria-checked', 'false');

	// Remove selection tags
	var tags = el.find('.selection-tag');
	tags.remove();

	// Remove value
	var uberselectButton = el.find('.uberselect-button');
	uberselectButton.attr('aria-label', uberselectButton.attr('data-label'));

	// Select each set value
	for (var i = 0; i < value.length; i++) {
		var option = el.find('.option[data-value="' + value[i] + '"]');
		if (option.length) {
			option.click();
		}
	}

	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets the new value for the uberselect.
 * @param el The uberselect field.
 */
bitte.ui.uberselect.reset = function (el) {
	el = $(el);

	// Remove options
	var options = el.find('.option');
	options.removeClass('checked');
	options.attr('aria-checked', 'false');

	// Remove selection tags
	var tags = el.find('.selection-tag');
	tags.remove();

	// Remove value
	var uberselectButton = el.find('.uberselect-button');
	uberselectButton.attr('aria-label', uberselectButton.attr('data-label'));

	el.trigger('ui-change');
	el.validate();

	el.trigger('reset');
};

/**
 * Sets whether or not the uberselect is enabled.
 * @param el The uberselect to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.uberselect.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
	} else {
		el.addClass('disabled');
	}
};

/**
 * Attaches functionality to the uberselect.
 * @param el The uberselect field.
 * @param id The unique ID assigned to the uberselect.
 */
bitte.ui.uberselect.bind = function (el, id) {
	var uberselect = $(el).find('.uberselect');
	var input = $(el).find('.input');
	var button = $(el).find('.uberselect-button');
	var placeholder = $(el).find('.placeholder');
	var dropdownContainer = $(el).find('.dropdown-container');
	var listbox = $(el).find('.listbox');
	var options = listbox.find('.option');
	var focusables = uberselect.find('.focusable').not('.no-match'); // Items that can be focused (selections, input, options)
	var noResults = listbox.find('.no-results');
	var suggestionThreshold = 1; // Minimum characters to start suggesting options
	var isActive = false;
	var currentItemIndex = -1;
	var currentValues = [];
	var keys = {
		tab: 9,
		esc: 27,
		left: 37,
		up: 38,
		right: 39,
		down: 40
	};

	var updateButtonHeight = function() {
		window.requestAnimationFrame(function() {
			button.css('height', uberselect.find('.button-wrapper').outerHeight());
		});
	};

	updateButtonHeight();

	$(el).on('reset', function() {
		focusables = uberselect.find('.focusable').not('.no-match');
		isActive = false;
		currentItemIndex = -1;
		currentValues = [];
	});

	var stopEvent = function(event) {
		event.stopPropagation();
		event.preventDefault();
	};

	var focusInput = function() {
		options.attr('tabindex', '-1');
		input.focus();
		currentItemIndex = focusables.index(input);
	};

	var addFocusToItem = function(index) {
		focusables.eq(index).attr('tabindex', '0');
		focusables.eq(index).focus();
	};

	var removeFocusFromItem = function(index) {
		focusables.eq(index).attr('tabindex', '-1');
	};

	var switchFocusToItem = function(index) {
		removeFocusFromItem(currentItemIndex);
		addFocusToItem(index);
		currentItemIndex = index;
	};

	var focusPreviousItem = function() {
		if (currentItemIndex > 0) {
			switchFocusToItem(currentItemIndex - 1);
		}
	};

	var focusNextItem = function() {
		if (currentItemIndex < focusables.length - 1) {
			switchFocusToItem(currentItemIndex + 1);
		}
	};

	var updateValue = function() {
		var currentValueDisplays = [];
		for (var i = 0; i < currentValues.length; i++) {
			currentValueDisplays.push(currentValues[i].display);
		}
		if (currentValueDisplays.length > 0) {
			button.attr('aria-label', currentValueDisplays.join(', '));
		} else {
			button.attr('aria-label', button.attr('data-label'));
		}

		// Update list of focusables
		focusables = uberselect.find('.focusable').not('.no-match');
	};

	var addValue = function(option) {
		currentValues.push({
			value: $(option).attr('data-value'),
			display: $(option).text()
		});
		updateValue();
	};

	var removeValue = function(option) {
		for (var i = 0; i < currentValues.length; i++) {
			if (currentValues[i].value === $(option).attr('data-value')) {
				currentValues.splice(i, 1);
			}
		}
		updateValue();
	};

	var addSelectionTag = function(option) {
		var display = $(option).text();
		var value = $(option).attr('data-value');

		// Make sure the tag is not already selected
		if ($(button).find('[data-value="' + value + '"]').length > 0) {
			return;
		}

		// Mark this option as selected
		$(option).addClass('checked');
		$(option).attr('aria-checked', 'true');

		// Add the selection tag
		var selectionTag = $('<button class="selection-tag focusable" role="button" aria-label="' + display + ', remove this item from selection' + '" type="button" data-value="' + value + '" tabindex="-1">' + display + '</button>');
		uberselect.find('.button-wrapper').append(selectionTag);

		// Add value
		addValue(option);

		// Add listener for click to remove
		selectionTag.on('click', function(event) {
			var tag = $(event.target);

			var newFocusableIndex = focusables.index(tag);

			// Remove the selection tag
			var selectedValue = tag.attr('data-value');
			var option = options.filter('[data-value="' + selectedValue + '"]');
			removeSelectionTag(option, tag);

			// If dropdown is open, focus the next thing. Else, focus button
			if (button.hasClass('active')) {
				switchFocusToItem(newFocusableIndex);
			} else {
				button.focus();
			}

			// Prevent a click event on the container
			event.stopPropagation();
		});

		el.trigger('ui-change');
	};

	var removeSelectionTag = function(option, tag) {
		// Remove option class
		option.removeClass('checked');
		option.attr('aria-checked', 'false');

		// Remove selection tag
		tag.remove();

		// Remove value
		removeValue(option);

		el.trigger('ui-change');
	};

	// UI Change adjustments
	$(el).on('ui-change', function() {
		if ($(el).find('.selection-tag').length > 0) {
			placeholder.hide();
		} else {
			placeholder.show();
		}

		updateButtonHeight();
	});

	var keydownHandler = function(event) {
		// Get the key
		var key = event.which;

		// Set keyboard controls
		switch (key) {
			case keys.tab:
				closeDropdown();
				removeFocusFromItem(currentItemIndex);
				button.focus();
				break;
			case keys.esc:
				closeDropdown();
				removeFocusFromItem(currentItemIndex);
				button.focus();
				stopEvent(event);
				break;
			case keys.up:
			case keys.left:
				focusPreviousItem();
				stopEvent(event);
				break;
			case keys.down:
			case keys.right:
				focusNextItem();
				stopEvent(event);
				break;
		}
	};

	var keyupHandler = function(event) {
		if (input.val().length >= suggestionThreshold) {
			// Set visibility of options
			options.each(function() {
				if ($(this).text().toLowerCase().indexOf(input.val().toLowerCase()) !== -1) {
					// If it contains the input value, make it a match
					$(this).addClass('match').removeClass('no-match');
				} else {
					// If it does not contain the input value, remove it as a match
					$(this).removeClass('match').addClass('no-match');
				}
			});

			// Show listbox, if there are matches to show
			if ($(el).find('.match').length > 0) {
				openListbox();
				noResults.hide();
			} else {
				noResults.show();
			}
		} else {
			// Reset visibility of options
			options.addClass('match').removeClass('no-match');
			noResults.hide();

			// Reset index
			var currentItemIndex = -1;
		}

		// Update list of focusables
		focusables = uberselect.find('.focusable').not('.no-match');
	};

	var clickHandler = function(event) {
		var option = $(event.target);

		// Add selection to group
		if (option.hasClass('checked')) {
			var tag = $(el).find('.selection-tag[data-value="' + option.attr('data-value') + '"]');
			removeSelectionTag(option, tag);
		} else {
			addSelectionTag(option);
		}

		// Focus this option
		switchFocusToItem(focusables.index(option));
	};

	var clearInput = function() {
		input.val('');
	};

	var openListbox = function() {
		// Activate menu
		isActive = true;
		button.attr('aria-expanded', 'true');

		// Add active style
		listbox.addClass('is-active');

		// Reset
		var currentItemIndex = -1;
	};

	var closeListbox = function() {
		// Deactivate menu
		isActive = false;
		button.attr('aria-expanded', 'false');

		// Remove active style
		listbox.removeClass('is-active');

		// Reset
		var currentItemIndex = -1;
	};

	var closeOnOutsideClick = function(event) {
		var clickArea = el.find('.uberselect');
		if (!$(event.target).closest(clickArea).length) {
			button.focus();
			closeDropdown();
		}
	};

	var openDropdown = function() {
		button.addClass('active');
		dropdownContainer.show();
		switchFocusToItem(0);

		openListbox();
		options.addClass('match').removeClass('no-match');
		noResults.hide();
		var currentItemIndex = -1;

		// Start listening
		$(document).on('click', closeOnOutsideClick);
		$(document).on('touchstart', closeOnOutsideClick);
		$(el).on('keydown', keydownHandler);
		$(el).on('keyup', keyupHandler);
	};

	var closeDropdown = function() {
		button.removeClass('active');
		dropdownContainer.hide();
		closeListbox();

		clearInput();

		// Stop listening
		$(document).off('click', closeOnOutsideClick);
		$(document).off('touchstart', closeOnOutsideClick);
		$(el).off('keydown', keydownHandler);
		$(el).off('keyup', keyupHandler);
	};

	uberselect.find('.button-wrapper').on('click', function() {
		button.focus();
		buttonClick();
	});

	input.on('focus', function() {
		currentItemIndex = focusables.index(input);
	});

	var buttonClick = function() {
		if (button.hasClass('active')) {
			closeDropdown();
		} else {
			openDropdown();
		}
	};

	options.on('click', clickHandler);
	button.on('click', buttonClick);
};

// ----- Combobox -----

/**
 * The core combobox object.
 */
bitte.ui.combobox = bitte.ui.combobox || {};

/**
 * Creates a new combobox element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.combobox.create = function (data, el) {
	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'combobox';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['placeholder'] = data['placeholder'] || '';
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.combobox.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	var listboxId = bitte.generateID();
	var combobox = $('<div class="combobox" role="combobox" aria-expanded="false" aria-owns="' + listboxId + '" aria-labelledby="' + data['labelId'] + '"></div>');
	var input = $('<input class="input" type="text" aria-autocomplete="list" aria-controls="' + listboxId + '" placeholder="' + data['placeholder'] + '"aria-labelledby="' + data['labelId'] + '">');
	combobox.append(input);
	var listbox = $('<ul class="listbox" role="listbox" id="' + listboxId + '"></ul>');

	// Check if required.
	if (data['required']) {
		listbox.attr('aria-required', 'true');
	}

	// Check if disabled
	if (data['disabled']) {
		input.prop('disabled', 'true');
	}

	// Create options.
	var option;
	for (var i = 0; i < data['options'].length; i++) {
		var value = data['options'][i].value;
		var display = data['options'][i].display;
		option = $('<li><button type="button" class="option" role="option" tabindex="-1" data-value="' + value + '">' + display + '</button></li>');
		listbox.append(option);
	}

	// Add all elements.
	field.append(combobox);
	field.append(listbox);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'combobox');
	field.data('name', data['name']);
	field.data('validator', data['validate']);
	field.data('placeholder', data['placeholder']);

	// Bind functionality to element.
	bitte.ui.combobox.bind(field, data['id']);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a combobox.
 */
bitte.ui.combobox.validator = function (required, messages) {
	return function (value) {
		if (required && !value) {
			return messages['nullValue'] || 'Please enter a value.';
		} else {
			return true;
		}
	};
};

/**
 * Retrieves the selected item from the combobox.
 * @param el The combobox to retrieve the value from.
 */
bitte.ui.combobox.fetch = function (el) {
	el = $(el);
	var value = el.find('.input').val();
	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Sets the new value for the combobox.
 * @param el The combobox field.
 * @param value The value to set.
 */
bitte.ui.combobox.setValue = function (el, value) {
	el = $(el);
	el.find('.input').val(value);
	el.trigger('ui-change');
	el.validate();
};

/**
 * Resets the combobox.
 * @param el The combobox field.
 */
bitte.ui.combobox.reset = function (el) {
	el = $(el);
	el.find('.input').val('');
	el.trigger('ui-change');
	el.validate();

	el.find('.option').removeClass('match');
	el.trigger('reset');
};

/**
 * Sets whether or not the combobox is enabled.
 * @param el The combobox to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.combobox.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
	} else {
		el.addClass('disabled');
	}
};

/**
 * Attaches functionality to the combobox.
 * @param el The combobox field.
 * @param id The unique ID assigned to the combobox.
 */
bitte.ui.combobox.bind = function (el, id) {
	var combobox = $(el).find('.combobox');
	var input = $(el).find('.input');
	var listbox = $(el).find('.listbox');
	var options = listbox.find('.option');
	var matches; // Subset of options that have the input value as a substring
	var suggestionThreshold = 1; // Minimum characters to start suggesting options
	var isActive = false;
	var currentItemIndex = -1;
	var currentValue = el.fetch().value;
	var keys = {
		tab: 9,
		esc: 27,
		up: 38,
		down: 40
	};

	$(el).on('reset', function() {
		matches = listbox.find('.match');
		isActive = false;
		currentItemIndex = -1;
		currentValue = el.fetch().value;
	});

	var stopEvent = function(event) {
		event.stopPropagation();
		event.preventDefault();
	};

	var focusInput = function() {
		options.attr('tabindex', '-1');
		input.focus();
		currentItemIndex = -1;
	};

	var addFocusToItem = function(index) {
		matches.eq(index).attr('tabindex', '0');
		matches.eq(index).focus();
	};

	var removeFocusFromItem = function(index) {
		matches.eq(index).attr('tabindex', '-1');
	};

	var switchFocusToItem = function(index) {
		removeFocusFromItem(currentItemIndex);
		addFocusToItem(index);
		currentItemIndex = index;
	};

	var focusPreviousItem = function() {
		matches = listbox.find('.match');

		if (currentItemIndex > 0) {
			switchFocusToItem(currentItemIndex - 1);
		} else {
			focusInput();
		}
	};

	var focusNextItem = function() {
		matches = listbox.find('.match');

		if (currentItemIndex < matches.length - 1) {
			switchFocusToItem(currentItemIndex + 1);
		}
	};

	var keydownHandler = function(event) {
		// Get the key
		var key = event.which;

		// Set keyboard controls
		switch (key) {
			case keys.tab:
				closeListbox();
				focusInput();
				break;
			case keys.esc:
				clearInput();
				focusInput();
				stopEvent(event);
				break;
			case keys.up:
				focusPreviousItem();
				stopEvent(event);
				break;
			case keys.down:
				focusNextItem();
				stopEvent(event);
				break;
		}
	};

	var keyupHandler = function(event) {
		if (input.val().length >= suggestionThreshold) {
			// Set visibility of options
			options.each(function() {
				if ($(this).text().toLowerCase() === input.val().toLowerCase()) {
					// If it is exactly the input value, remove it as a match
					$(this).removeClass('match');
				} else if ($(this).text().toLowerCase().indexOf(input.val().toLowerCase()) !== -1) {
					// If it contains the input value, make it a match
					$(this).addClass('match');
				} else {
					// If it does not contain the input value, remove it as a match
					$(this).removeClass('match');
				}
			});

			// Show listbox, if there are matches to show
			if ($(el).find('.match').length > 0) {
				openListbox();
			} else {
				closeListbox();
			}
		} else {
			// Reset visibility of options
			options.removeClass('match');

			// Reset index
			var currentItemIndex = -1;

			// Hide listbox, if visible
			closeListbox();
		}
	};

	var clickHandler = function(event) {
		input.val($(event.target).attr('data-value'));
		closeListbox();
		focusInput();
		keyupHandler(event);

		el.trigger('ui-change');
	};

	var clearInput = function() {
		input.val('');
	};

	var closeOnOutsideClick = function(event) {
		var comboboxClickArea = el.find('.combobox');
		var listboxClickArea = el.find('.listbox');
		if (!$(event.target).closest(comboboxClickArea).length && !$(event.target).closest(listboxClickArea).length) {
			// Need to do this so that if the text input is focused,
			// iOS will close the keyboard tray. Otherwise it thinks
			// the input is still focused
			input.focus();
			input.blur();

			closeListbox();
		}
	};

	var openListbox = function() {
		// Activate menu
		isActive = true;
		combobox.attr('aria-expanded', 'true');

		// Add active style
		listbox.addClass('is-active');

		// Reset
		var currentItemIndex = -1;


		// Start listening for outside clicks
		$(document).on('click', closeOnOutsideClick);
		$(document).on('touchstart', closeOnOutsideClick);
	};

	var closeListbox = function() {
		// Deactivate menu
		isActive = false;
		combobox.attr('aria-expanded', 'false');

		// Remove active style
		listbox.removeClass('is-active');

		// Reset
		var currentItemIndex = -1;

		// Stop listening for outside clicks
		$(document).off('click', closeOnOutsideClick);
		$(document).off('touchstart', closeOnOutsideClick);
	};

	input.on('focus', function() {
		// Show listbox, if there are matches to show
		if ($(el).find('.match').length > 0) {
			openListbox();
		}
	});

	$(el).on('keydown', keydownHandler);
	$(el).on('keyup', keyupHandler);
	options.on('click', clickHandler);
};

// ----- Dropdown -----

/**
 * The core dropdown object.
 */
bitte.ui.dropdown = bitte.ui.dropdown || {};

/**
 * Creates a new dropdown element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.dropdown.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'dropdown';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['default'] = data['default'] || '';
	data['placeholder'] = data['placeholder'] || '';
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.dropdown.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	var dropdownMenuId = bitte.generateID();
	var dropdownButton = $('<button class="dropdown-button" type="button" role="button" aria-controls="' + dropdownMenuId + '" aria-haspopup="true" aria-expanded="false" aria-labelledby="' + data['labelId'] + '" data-placeholder="' + data['placeholder'] + '">' + data['placeholder'] + '</button>');
	var dropdownMenu = $('<ul class="dropdown-menu" id="' + dropdownMenuId + '" role="menu"></ul>');

	// Check if required.
	if (data['required']) {
		dropdownMenu.attr('aria-required', 'true');
	}

	// Check if disabled
	if (data['disabled']) {
		dropdownButton.prop('disabled', 'true');
	}

	// Create option groups for the dropdown.
	var option;
	for (var i = 0; i < data['options'].length; i++) {
		var display = data['options'][i]['display'] || data['options'][i]['value'];
		var style = data['options'][i]['style'] || '';
		if (data['options'][i]['label']) {
			style = 'dropdown-label ' + style;
		} else {
			style = 'dropdown-item ' + style;
		}
		option = $('<li><button type="button" class="' + style + '" data-value="' + data['options'][i]['value'] + '" role="menuitem" tabindex="-1">' + display + '</button></li>');

		dropdownMenu.append(option);
	}

	// Add all elements to the dropdown.
	field.append(dropdownButton);
	field.append(dropdownMenu);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'dropdown');
	field.data('name', data['name']);
	field.data('validator', data['validate']);
	field.data('placeholder', data['placeholder']);

	// Bind functionality to element.
	bitte.ui.dropdown.bind(field, data['id']);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (data['default'] != '') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a dropdown.
 */
bitte.ui.dropdown.validator = function (required, messages) {
	return function (value) {
		if (required && !value) {
			return messages['nullValue'] || 'Please select an option.';
		} else {
			return true;
		}
	};
};

/**
 * Retrieves the selected item from the dropdown.
 * @param el The dropdown to retrieve the value from.
 */
bitte.ui.dropdown.fetch = function (el) {
	el = $(el);
	var value;
	if (el.find('.checked').length) {
		value = el.find('.checked').data('value');
	} else {
		value = null;
	}
	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Sets the new value for the dropdown.
 * @param el The dropdown field.
 * @param value The value to set.
 */
bitte.ui.dropdown.setValue = function (el, value) {
	el = $(el);
	var dropdown = el.find('.bitte-ui'); // The dropdown ui piece.
	var item = dropdown.find('.dropdown-item[data-value="' + value + '"]');
	if (item.length > 0) { // An item was found, select it instead.
		item.click();
	} else { // No item found, remove selection.
		bitte.ui.dropdown.reset(el);
	}
};

/**
 * Resets the dropdown.
 * @param el The dropdown field.
 */
bitte.ui.dropdown.reset = function (el) {
	el = $(el);
	var dropdown = el.find('.bitte-ui'); // The dropdown ui piece.
	var dropdownButton = dropdown.find('.dropdown-button');
	var dropdownItems = dropdown.find('.dropdown-item');

	dropdownItems.removeClass('checked'); // Deselect all values.
	dropdownButton.removeClass('has-value'); // Remove class
	dropdownButton.text(dropdownButton.attr('data-placeholder')); // Set the placeholder text back.
	el.trigger('ui-change');
	el.validate();

	el.trigger('reset');
};

/**
 * Sets whether or not the dropdown is enabled.
 * @param el The dropdown to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.dropdown.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
	} else {
		el.addClass('disabled');
	}
};

/**
 * Attaches functionality to the dropdown.
 * @param el The dropdown field.
 * @param id The unique ID assigned to the dropdown.
 */
bitte.ui.dropdown.bind = function (el, id) {
	var button = $(el).find('.dropdown-button');
	var menu = $(el).find('.dropdown-menu');
	var items = menu.find('.dropdown-item');
	var isActive = false;
	var currentItemIndex = 0;
	var checkedItemIndex = null;
	var currentValue = el.fetch().value;
	var keys = {
		tab: 9,
		esc: 27,
		end: 35,
		home: 36,
		up: 38,
		down: 40
	};

	$(el).on('reset', function() {
		isActive = false;
		currentItemIndex = 0;
		checkedItemIndex = null;
		currentValue = el.fetch().value;
	})

	var isPrintableCharacter = function(string) {
		return string.length === 1 && string.match(/\S/);
	};

	var stopEvent = function(event) {
		event.stopPropagation();
		event.preventDefault();
	};

	var focusButton = function() {
		button.focus();
	};

	var addFocusToItem = function(index) {
		items.eq(index).attr('tabindex', '0');
		items.eq(index).focus();
		currentItemIndex = index;
	};

	var removeFocusFromItem = function(index) {
		items.eq(index).attr('tabindex', '-1');
	};

	var switchFocusToItem = function(index) {
		removeFocusFromItem(currentItemIndex);
		addFocusToItem(index);
	};

	var focusFirstItem = function() {
		switchFocusToItem(0);
	};

	var focusLastItem = function() {
		switchFocusToItem(items.length - 1);
	};

	var focusPreviousItem = function() {
		if (currentItemIndex > 0) {
			switchFocusToItem(currentItemIndex - 1);
		} else {
			switchFocusToItem(items.length - 1);
		}
	};

	var focusNextItem = function() {
		if (currentItemIndex < items.length - 1) {
			switchFocusToItem(currentItemIndex + 1);
		} else {
			switchFocusToItem(0);
		}
	};

	var focusNextCharMatch = function(char) {
		// Search for a match after the current item
		var matchIndex = getNextCharMatch(char, currentItemIndex + 1, items.length);

		// If not found, search for a match before the current item
		if (matchIndex === -1) {
			matchIndex = getNextCharMatch(char, 0, currentItemIndex);
		}

		// If found, focus the item
		if (matchIndex !== -1) {
			switchFocusToItem(matchIndex);
		}
	};

	var getNextCharMatch = function(char, startIndex, endIndex) {
		// Iterate through the specified range
		for (var i = startIndex; i < endIndex; i++) {
			// If the first character of this menu item is a match, return the index
			if (items[i].textContent.substring(0, 1).toLowerCase() === char.toLowerCase()) {
				return i;
			}
		}

		// No match found
		return -1;
	};

	var keypressHandler = function(event) {
		// Get the char
		var char = String.fromCharCode(event.charCode);

		// If char is valid, attempt to focus the next item that starts with char
		if (isPrintableCharacter(char)) {
			focusNextCharMatch(char);
		}
	};

	var keydownHandler = function(event) {
		// Get the key
		var key = event.which;

		// Set keyboard controls
		switch (key) {
			case keys.tab:
				closeMenu();
				break;
			case keys.esc:
				closeMenu();
				stopEvent(event);
				break;
			case keys.up:
				focusPreviousItem();
				stopEvent(event);
				break;
			case keys.down:
				focusNextItem();
				stopEvent(event);
				break;
			case keys.home:
				focusFirstItem();
				stopEvent(event);
				break;
			case keys.end:
				focusLastItem();
				stopEvent(event);
				break;
		}
	};

	var clickHandler = function(event) {
		var selected = $(event.target);

		var newValue = selected.data('value');

		// If the value has changed...
		if (newValue != currentValue) {
			// Update classes.
			items.removeClass('checked');
			selected.addClass('checked')

			// Update values.
			checkedItemIndex = selected.parent().index();
			currentValue = newValue;

			// Update display.
			button.text(selected.text());
			button.addClass('has-value');

			// Trigger events.
			el.trigger('ui-change');
			el.validate();
		}

		closeMenu();
	};

	var closeOnOutsideClick = function(event) {
		if (!$(event.target).closest('.dropdown-button').length && !$(event.target).closest('.dropdown-menu').length) {
			closeMenu();
		}
	};

	var openMenu = function() {
		// Activate menu
		isActive = true;
		button.attr('aria-expanded', 'true');

		// Add active style
		button.addClass('is-active');
		menu.addClass('is-active');

		// Set focus
		if (checkedItemIndex) {
			addFocusToItem(checkedItemIndex);
		} else {
			focusFirstItem();
		}

		// Start listening for user input
		menu.on('keydown', keydownHandler);
		menu.on('keypress', keypressHandler);
		$(document).on('click', closeOnOutsideClick);
		$(document).on('touchstart', closeOnOutsideClick);
	};

	var closeMenu = function() {
		// Deactivate menu
		isActive = false;
		button.attr('aria-expanded', 'false');

		// Remove active style
		button.removeClass('is-active');
		menu.removeClass('is-active');

		// Reset Focus
		removeFocusFromItem(currentItemIndex);
		focusButton();

		// Stop listening for user input
		menu.off('keydown', keydownHandler);
		menu.off('keypress', keypressHandler);
		$(document).off('click', closeOnOutsideClick);
		$(document).off('touchstart', closeOnOutsideClick);
	};

	var toggleMenu = function(event) {
		// Determine whether to close or open menu
		if (isActive) {
			closeMenu();
		} else {
			openMenu();
		}

		// Prevent this from triggering a click on the document
		event.stopPropagation();
	};

	items.on('click', clickHandler);
	button.on('click', toggleMenu);
};

// ----- Input -----

/**
 * The core input object.
 */
bitte.ui.input = bitte.ui.input || {};

/**
 * Creates a new input element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.input.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'input';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['fieldType'] = data['fieldType'] || 'text';
	data['placeholder'] = data['placeholder'] || '';
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.input.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	var input = $('<input aria-labelledby="' + data['labelId'] + '" placeholder="' + data['placeholder'] + '" type="' + data['fieldType'] + '">');

	// Check if required.
	if (data['required']) {
		input.attr('aria-required', 'true');
	}

	field.append(input);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'input');
	field.data('name', data['name']);
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.input.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by an input field.
 */
bitte.ui.input.validator = function (required, messages) {
	return function (value) {
		if (required && value == '') {
			return messages['nullValue'] || 'Please enter a value.';
		} else {
			return true;
		}
	};
};

/**
 * Retrieves the data entered into the input.
 * @param el The input to retrieve the value from.
 */
bitte.ui.input.fetch = function (el) {
	el = $(el);
	var value = el.find('input').val();
	if (el.find('input[type="number"]').length) { // If the field is specifically a number field, try to parse the value.
		value = parseInt(value, 10);
		if (isNaN(value)) { // If the value couldn't be parsed.
			value = null;
		}
	}

	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Sets the new value for the input.
 * @param el The input field.
 * @param value The value to set.
 */
bitte.ui.input.setValue = function (el, value) {
	el = $(el);
	if (value) {
		el.find('input').val(value);
	} else { // In the case of null/false/etc.
		el.find('input').val('');
	}
	el.trigger('ui-change');
	el.validate();
};

/**
 * Resets the input.
 * @param el The input field.
 */
bitte.ui.input.reset = function (el) {
	el = $(el);
	el.find('input').val('');

	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the input field is enabled.
 * @param el The input field to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.input.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
		el.find('input').prop('disabled', false);
	} else {
		el.addClass('disabled');
		el.find('input').prop('disabled', true);
	}
};

/**
 * Attaches functionality to the input.
 * @param el The input field.
 */
bitte.ui.input.bind = function (el) {
	el = $(el);
	el.on('change', 'input', function () {
		el.trigger('ui-change');
		el.validate();
	});
};

// ----- Number -----

/**
 * The core number object.
 */
bitte.ui.number = bitte.ui.number || {};

/**
 * Creates a new number element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.number.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'number';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['decimal'] = data['decimal'] || false;
	data['placeholder'] = data['placeholder'] || '';
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.number.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	field.append('<input aria-labelledby="' + data['labelId'] + '" placeholder="' + data['placeholder'] + '" type="text">');

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'number');
	field.data('name', data['name']);
	field.data('decimal', data['decimal']);
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.number.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	data['default'] = data['default'] || 0; // Default to 0 in the case of undefined/null/etc.
	field.setValue(data['default']);

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a number field.
 */
bitte.ui.number.validator = function (required, messages) {
	return function (value) {
		if (required) {
			if (value === null) {
				return messages['nullValue'] || 'Please enter a number.';
			}
		}
		if (typeof value == 'undefined') {
			return messages['notNumber'] || 'The value must be a number.';
		}
		return true;
	};
};

/**
 * Retrieves the data entered into the number field.
 * @param el The number field to retrieve the value from.
 */
bitte.ui.number.fetch = function (el) {
	el = $(el);
	var value = el.find('input').val().replace(/,/g, '');
	if (value != '') {
		value = parseInt(value, 10);
		if (isNaN(value)) {
			value = undefined;
		}
	} else {
		value = null;
	}

	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Sets the new value for the number field.
 * @param el The number field.
 * @param value The value to set.
 */
bitte.ui.number.setValue = function (el, value) {
	el = $(el);
	value = value || 0; // Default to 0 in case of null/false/etc.
	el.data('oldvalue', value);
	el.data('oldposition', String(value).length);
	el.find('input').val(value);

	bitte.ui.number.formatNumber(el);

	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the number field is enabled.
 * @param el The number field to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.number.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
		el.find('input').prop('disabled', false);
	} else {
		el.addClass('disabled');
		el.find('input').prop('disabled', true);
	}
};

/**
 * Handles updating/storing the value and caret position based on characters added/removed.
 * @param el The number field.
 */
bitte.ui.number.formatNumber = function (el) {
	el = $(el);
	var input = el.find('input');

	var val = input.val(); // Retrieve value.
	var len = val.length; // Count characters before reformat.
	val = val.replace(/,/g, ''); // Remove all commas.

	val = val.replace(/^(-?)0+/g, '$1'); // Remove all leading zeroes (make sure to keep the dash intact if it is there).
	if (val == '') { // Fully erased.
		input[0].setSelectionRange(0, 0); // Make sure selection is at the end.
		el.data('oldposition', 0); // Store caret position.
		el.data('oldvalue', val); // Store new value.
		input.val(val); // Update input's current value.
		return;
	}
	if (val == '-') { // Only - typed, initialize to a valid '-0'.
		val = '-0';
		input[0].setSelectionRange(2, 2); // Make sure selection is at the end.
	}

	// Support Decimals?
	var reg = /^-?(?:[1-9]\d*|0)$/; // Integer regex.
	if (el.data('decimal') == true) {
		reg = /^-?(?:[1-9]\d*\.\d*|[1-9]\d*|0?\.\d*|0)$/; // Decimal regex.
	}

	if (val.match(reg) != null) { // Ensure the string is a valid number (int).

		val = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); // Add commas into the currently valid number.
		el.data('oldvalue', val); // Store new value.
		if (val.length > len) { // Comma must have been added.
			len = 1; // Offset will be +1.
		} else if (val.length < len) { // Comma must have been lost.
			len = -1; // Offset will be -1.
		} else {
			len = 0; // Offset will not change.
		}
		el.data('oldposition', input[0].selectionStart + len); // Store new caret position, including offset.
		input.val(val); // Update input's current value.
		input[0].setSelectionRange(el.data('oldposition'), el.data('oldposition')); // Keep caret position.
		return;
	} else { // Not a valid number.
		input.val(el.data('oldvalue')); // Revert to the previous input.
		input[0].setSelectionRange(el.data('oldposition'), el.data('oldposition')); // Revert to the previous caret position.
		return;
	}
};

/**
 * Attaches functionality to the number field.
 * @param el The number field.
 */
bitte.ui.number.bind = function (el) {
	el = $(el);

	el.on('keydown', 'input', function (e) {
		if (el.hasClass('disabled')) { // Ignore input when disabled.
			return;
		}
		var input = el.find('input');
		var start = input[0].selectionStart;
		var end = input[0].selectionEnd;
		var val = input.val();
		if (e.which == 8 && start == end && val.charAt(start - 1) == ',') { // Comma before the caret while backspacing at a position.

			val = val.slice(0, start - 2) + val.slice(start); // Cut out comma and preceeding character.
			input.val(val); // Set new value with characters removed.
			input[0].setSelectionRange(start - 2, start - 2); // Make sure caret is placed at the location the characters were removed.

			bitte.ui.number.formatNumber(el);

			e.preventDefault(); // Prevent normal removal of character.
			return false;
		}
		if (e.which == 46 && start == end && val.charAt(start) == ',') { // Comma after the caret while deleting at a position.

			val = val.slice(0, start) + val.slice(start + 2); // Cut out comma and succeeding character.
			input.val(val); // Set new value with characters removed.
			input[0].setSelectionRange(start, start); // Make sure caret is placed at the location the characters were removed.

			bitte.ui.number.formatNumber(el);

			e.preventDefault(); // Prevent normal removal of character.
			return false;
		}
	});

	el.on('input', 'input', function () {
		bitte.ui.number.formatNumber(el);
	});

	el.on('change', 'input', function () {

		el.trigger('ui-change');
		el.validate();
	});

	bitte.ui.number.formatNumber(el);
};

// ----- Button -----

/**
 * The core button object.
 */
bitte.ui.button = bitte.ui.button || {};

/**
 * Creates a new button element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.button.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'button';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['href'] = data['href'] || 'javascript:void(0)';
	data['placeholder'] = data['placeholder'] || '';
	data['action'] = data['action'] || function () {};
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['validate'] = data['validate'] || bitte.ui.button.validator(data['required']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	field.append('<a aria-labelledby="' + data['labelId'] + '" class="button" href="' + data['href'] + '"><span>' + data['placeholder'] + '</span></a>');

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'button');
	field.data('name', data['name']);
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.button.bind(field, data['action']);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a button field.
 */
bitte.ui.button.validator = function (required) {
	return function (value) {
		return true;
	};
};

/**
 * Retrieves the button set value (why anyone would do this...).
 * @param el The button to retrieve the value from.
 */
bitte.ui.button.fetch = function (el) {
	el = $(el);

	return {
		'name' : el.data('name'),
		'value' : el.data('value')
	}
};

/**
 * Sets the new value for the button.
 * @param el The button.
 * @param value The value to set.
 */
bitte.ui.button.setValue = function (el, value) {
	el = $(el);
	el.data('value');

	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the button is enabled.
 * @param el The button to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.button.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
	} else {
		el.addClass('disabled');
	}
};

/**
 * Attaches functionality to the button.
 * @param el The button.
 * @param action The callback to call when the button is clicked.
 */
bitte.ui.button.bind = function (el, action) {
	el = $(el);

	el.find('.bitte-ui .button').on('click', function(e) {

		if (el.hasClass('disabled')) { // Ignore input when disabled.
			e.preventDefault();
			return;
		}

		action();
		el.trigger('ui-change');
		el.validate();
	});
};

// ----- Date -----

/**
 * The core date object.
 */
bitte.ui.date = bitte.ui.date || {};

/**
 * Creates a new date input element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.date.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'date';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['format'] = data['format'] || 'yy-mm-dd';
	data['placeholder'] = data['placeholder'] || '';
	data['title'] = data['title'] || '';
	data['timestamp'] = typeof data['timestamp'] == 'undefined' ? false : data['timestamp'];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.date.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	if ($.fn.datepicker) { // We have access to the datepicker library.
		field.append('<input aria-labelledby="' + data['labelId'] + '" placeholder="' + data['placeholder'] + '" type="text" title="' + data['title'] + '"><input class="bitte-hidden" style="display: none;"><span class="cal-icon"></span>');
	} else { // We must use a fallback.
		field.append('<input placeholder="' + data['placeholder'] + '" type="date" title="' + data['title'] + '"><span class="cal-icon"></span>');
	}

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'date');
	field.data('name', data['name']);
	field.data('validator', data['validate']);
	field.data('format', data['format']);
	field.data('timestamp', data['timestamp']);

	// Bind functionality to element.
	bitte.ui.date.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a date field.
 */
bitte.ui.date.validator = function (required, messages) {
	return function (value) {
		if (required) {
			if (value === null) {
				return messages['nullValue'] || 'Please select a date.';
			}
		}
		if (typeof value == 'undefined') {
			return messages['notDate'] || 'The value must be a valid date.';
		}
		return true;
	};
};

/**
 * Retrieves the data entered into the date field.
 * @param el The date field to retrieve the value from.
 */
bitte.ui.date.fetch = function (el) {
	el = $(el);

	var date;
	var rawdate = el.find('input:not(.bitte-hidden)').val(); // Pull the value from the visible field, variable format, possibly invalid.
	if ($.fn.datepicker) { // We have access to the datepicker library.
		date = el.find('input.bitte-hidden').val(); // Pull the value from the hidden field, in a known format.
		if (rawdate == '') { // Blank date.
			date = null;
		} else if (date) { // Date is set to something, a date has been chosen at least once.
			date = new Date(parseInt(date)); // Convert the selected date (ticks as a string) to an actual date object.
			var tempdate = $.datepicker.formatDate(el.data('format'), date); // Convert to the textual representation being used.
			if (tempdate == rawdate) { // Backend value matches frontend value, we're good to go.
				if (el.data('timestamp')) { // Convert the given date to a timestamp.
					date = date.getTime() / 1000; // Convert validated date back to the timestamp.
				} else { // Return the textual representation as expected with the given format.
					date = tempdate; // Return the validated, formatted temporary date.
				}
			} else { // Backend value does not match frontend, date must be invalid (or some other thing happend to make it out of sync).
				date = undefined;
			}
		} else { // Partial date typed.
			date = undefined;
		}
	} else { // We must use a fallback instead of the date picker.
		if (rawdate.match(/\d{4}-\d{2}-\d{2}/)) { // Make sure date is in YYYY-MM-DD format.
			date = Date.parse(rawdate + 'T00:00:00Z');
			if (isNaN(date)) { // Not a valid date after all (odd month/day number?).
				date = undefined;
			}
			if (el.data('timestamp')) { // We want a timestamp.
				date = date / 1000; // Convert milliseconds to seconds.
			} else { // We want a formatted date.
				date = rawdate; // Use the original text, now that we know it's valid.
			}
		} else { // Invalid format.
			date = undefined;
		}
	}

	return {
		'name' : el.data('name'),
		'value' : date
	};
};

/**
 * Sets the new value for the date field.
 * @param el The date field.
 * @param value The value to set.
 */
bitte.ui.date.setValue = function (el, value) {
	el = $(el);
	if (value) {
		el.find('input').val(value);
	} else {
		el.find('input').val('');
	}
	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the number field is enabled.
 * @param el The number field to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.date.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
		el.find('input').prop('disabled', false);
	} else {
		el.addClass('disabled');
		el.find('input').prop('disabled', true);
	}
};

/**
 * Attaches functionality to the date field.
 * @param el The date field.
 */
bitte.ui.date.bind = function (el) {
	el = $(el);

	if ($.fn.datepicker) { // We have access to the datepicker library.

		// Initialize a datepicker.
		el.find('input:not(.bitte-hidden)').datepicker({
			'dateFormat' : el.data('format'),
			'altField' : el.find('input.bitte-hidden'),
			'altFormat' : '@', // Unix ticks (ms).
		});

	} else { // We must use a fallback.
		// Nothing special happens here.
	}

	// When a new date is selected or input changed.
	el.on('change', 'input:not(.bitte-hidden)', function () {

		el.trigger('ui-change');
		el.validate();
	});
};

// ----- Multiselect -----

/**
 * The core multiselect object.
 */
bitte.ui.multiselect = bitte.ui.multiselect || {};

/**
 * Creates a new multiselect.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.multiselect.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'multiselect';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['placeholder'] = data['placeholder'] || false;
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.multiselect.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	field.append('<div aria-labelledby="' + data['labelId'] + '" class="menu"></div>');

	// Add placeholder if defined.
	if (data['placeholder']) {
		field.find('.menu').append('<div class="placeholder">' + data['placeholder'] + '</div>');
	}

	// Create all select groups.
	var group = $('<div class="group"></div>');
	for (var i = 0; i < data['options'].length; i++) {
		var display = data['options'][i]['display'] || data['options'][i]['value'];
		var style = data['options'][i]['style'] || '';
		if (data['options'][i]['label']) {
			style = 'multiselect-label ' + style;
		} else {
			style = 'multiselect-item ' + style;
		}
		group.append($('<div class="' + style + '" data-value="' + data['options'][i]['value'] + '"><span>' + display + '</span></div>'));
	}

	// Merge all groups.
	field.find('.menu').append(group);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'multiselect');
	field.data('name', data['name']);
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.multiselect.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a multiselect.
 */
bitte.ui.multiselect.validator = function (required, messages) {
	return function (value) {
		if (required) {
			if (value.length <= 0) {
				return messages['nullValue'] || 'Please select at least one option.';
			}
		}
		return true;
	};
};

/**
 * Retrieves the data entered into the multiselect.
 * @param el The multiselect to retrieve the value from.
 */
bitte.ui.multiselect.fetch = function (el) {
	el = $(el);

	// Create an array of all selected values.
	var selection = [];
	el.find('.multiselect-item.active').each(function () {
		selection.push($(this).data('value'));
	});

	return {
		'name' : el.data('name'),
		'value' : selection
	};
};

/**
 * Sets the new value for the multiselect.
 * @param el The multiselect.
 * @param value The array of values to set.
 */
bitte.ui.multiselect.setValue = function (el, value) {
	el = $(el);

	// Clear any existing values.
	el.find('.active').removeClass('active');

	// Iterate over each value and try to find it, setting it as active if found.
	if (value) { // Only look for selections if values were provided, otherwise null/false/etc. clears.
		for (var i = 0; i < value.length; i++) {
			$(el).find('.group .multiselect-item[data-value="' + value[i] + '"]').addClass('active');
		}
	}
	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the multiselect is enabled.
 * @param el The multiselect to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.multiselect.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
	} else {
		el.addClass('disabled');
	}
};

/**
 * Attaches functionality to the multiselect.
 * @param el The multiselect.
 */
bitte.ui.multiselect.bind = function (el) {
	el = $(el);

	el.find('.multiselect-label').on('click', function (e) {
		e.preventDefault(); // Prevent text selection.
	});

	// Any option clicked toggles its active state.
	el.find('.multiselect-item').on('click', function (e) {

		e.preventDefault(); // Prevent text selection.

		if (el.hasClass('disabled')) { // Ignore input when disabled.
			return;
		}

		$(this).toggleClass('active');
		el.trigger("ui-change");
		el.validate();
	});
};

// ----- Search -----

/**
 * The core search object.
 */
bitte.ui.search = bitte.ui.search || {};

/**
 * Creates a new search field.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.search.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'search';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['appendable'] = data['appendable'] || false;
	data['placeholder'] = data['placeholder'] || '';
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.search.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	field.append('<div aria-labelledby="' + data['labelId'] + '" class="search-box"><input type="text" placeholder="' + data['placeholder'] + '"><span class="search-icon"></span></div>');
	field.append('<div class="search-results"></div>');
	field.append('<div class="selected"><div class="group"></div></div>');

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'search');
	field.data('name', data['name']);
	field.data('options', data['options']);
	field.data('appendable', data['appendable'])
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.search.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a search field.
 */
bitte.ui.search.validator = function (required, messages) {
	return function (value) {
		if (required) {
			if (value.length <= 0) {
				return messages['nullValue'] || 'Please select at least one option.';
			}
		}
		return true;
	};
};

/**
 * Retrieves the data entered into the search field.
 * @param el The search to retrieve the value from.
 */
bitte.ui.search.fetch = function (el) {
	el = $(el);

	// Create an array of all selected values.
	var selection = [];
	el.find('.selected .group .option.active').each(function () {
		selection.push($(this).data('value'));
	});

	return {
		'name' : el.data('name'),
		'value' : selection
	};
};

/**
 * Sets the new value for the search.
 * @param el The search field.
 * @param value The array of values to set.
 */
bitte.ui.search.setValue = function (el, value) {
	el = $(el);

	// Clear any existing values.
	el.find('.selected .option').remove();

	// Retrieve all options.
	var data = el.data('options');

	// Search for each given value amongst the set of options.
	if (value) { // Only look for selections if values were provided, otherwise null/false/etc. clears.
		for (var i = 0; i < value.length; i++) {
			for (var j = 0; j < data.length; j++) {
				if (data[j].value == value[i]) {
					var display = data[j]['display'] || data[j]['value'];
					var result = $('<div class="option active" data-value="' + data[j]['value'] + '">' + display + '</div>');
					el.find('.selected .group').append(result);
				}
			}
		}

		// Clicking an added result removes it.
		el.find('.selected .group').off().on('click.search', '.option.active', bitte.ui.search.removeGroup);

		// Clear the input and any existing search results.
		el.find('.search-box input').val('');
		el.find('.search-results').html('');
	}

	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the search field is enabled.
 * @param el The search field to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.search.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
		el.find('input').prop('disabled', false);
	} else {
		el.addClass('disabled');
		el.find('input').prop('disabled', true);
	}
};

/**
 * Removes a search option that is clicked.
 * @param el The group to remove.
 */
bitte.ui.search.removeGroup = function () {
	var el = $(this).closest('.bitte-field'); // Retrieve the underlying field element.

	var val = $(this).data('value');
	el.find('.search-results .option[data-value="' + val + '"]').removeClass('active');
	$(this).remove();

	el.trigger('ui-change');
	el.validate();
};

/**
 * Attaches functionality to the search.
 * @param el The search field.
 */
bitte.ui.search.bind = function (el) {
	el = $(el);

	// How this UI element works
	// User can search through a set of data attached in the data-options attribute
	// Upon searching in the text field, they will be presented with a list of matching results
	// Clicking on a result will store a copy of the result in a results box
	// If enabled a new item can be added to the full list and become accessible immediately

	function updateSearch() {
		// Clear any existing results.
		el.find('.search-results').html('');

		// Retrieve all options.
		var data = el.data('options');

		// Retrieve search text.
		var val = el.find('.search-box input').val();

		// Clicking a result adds it.
		el.find('.search-results').off().on('click.search', '.option', function () {
			var selected = $(this);
			if (!selected.hasClass('active')) {
				selected.addClass('active');
				el.find('.selected .group').append(selected.clone());

				// Clear any input from the search box.
				el.find('.search-box input').val('');

				// Clear all existing results.
				el.find('.search-results').html('');

				el.trigger('ui-change');
				el.validate();
			}
		});

		// Clicking an added result removes it.
		el.find('.selected .group').off().on('click.search', '.option.active', bitte.ui.search.removeGroup);

		// Iterate through the data set.
		for (var i = 0; i < data.length; i++) {
			// Check against display name if present, fallback to value.
			var display = data[i].display || data[i].value;
			// If found, create a result.
			if ((display.toLowerCase().indexOf(val.toLowerCase()) > -1) && (val.length > 1)) {
				var result = $('<div class="option" data-value="' + data[i].value + '">' + display + '</div>');
				if (el.find('.selected .group .option[data-value="' + data[i].value + '"]').length) {
					result.addClass('active');
				}
				el.find('.search-results').append(result);
			}
		}
	};

	function createNewItem() {
		// Update data array to include item.
		var data = el.data('options');
		var current = el.find('.search-box input').val();
		var newitem = {};

		// Check to see if this is already a valid item.
		var exists = false;
		var tag = 0;
		for (var i = 0; i < data.length; i++) {
			// Use display if present, fall back to value.
			var display = data[i]['display'] || data[i]['value'];

			var name = display.split(" (")[0].toLowerCase();
			if ((name == current.toLowerCase()) && (current.length > 1)) {
				exists = true;
				tag = data[i].value;
			}
		}

		if (exists) {
			// If the item already exists add it.
			// Grab already selected inputs and reset with new item.
			var tempvals = el.fetch().value || [];
			tempvals.push(tag);

			// Set Value.
			el.setValue(tempvals);
		} else {
			// If the item does not already exist, create and add.
			newitem.display = current;
			newitem.value = current;

			// Update data.
			data.push(newitem);
			el.data('options', data);

			// Grab already selected inputs and reset with new item.
			var tempvals = el.fetch().value || [];
			tempvals.push(current);

			// Set Value.
			el.setValue(tempvals);
		}

	};

	// Will attempt to highlight an available item.
	function itemHighlight(direction) {
		// If no item is highlighted assume you're starting from the search box.
		// Do not allow an up behavior from current highlighed item.

		// Vars.
		var currentitem = el.find('.search-results .option.highlighted');
		var firstitem = el.find('.search-results .option').first();
		var lastitem = el.find('.search-results .option').last();
		var previtem;
		var nextitem;

		// Previous item.
		if (currentitem.length == 0) {
			previtem = $('');
		} else if ($(currentitem).prev().length == 0) {
			previtem = $('');
		} else {
			previtem = $(el).find('.search-results .option.highlighted').prev();
		}

		// Next item.
		if (currentitem.length == 0) {
			nextitem = $(el).find('.search-results .option').first();
		} else if ($(currentitem).next().length == 0) {
			// We're at the end
			nextitem = $(currentitem);
		} else {
			nextitem = $(currentitem).next();
		}

		// Set highlighted item
		if (direction == 'up') {
			$(el).find('.search-results .option.highlighted').removeClass('highlighted');
			$(previtem).addClass('highlighted');
		} else if (direction == 'down') {
			$(el).find('.search-results .option.highlighted').removeClass('highlighted');
			$(nextitem).addClass('highlighted');
		} else {
			// No behavior
		}

		// Scroll Select into View
		var height = 0;
		var set = false;

		if ($(el).find('.search-results .option.highlighted').length == 0) {
			set = true;
		}

		// Cycle through all previous options to calculate offset
		$(el).find('.search-results .option').each(function () {
			if (set == false) {
				height += $(this).height();
			}

			if ($(this).hasClass('highlighted')) {
				set = true;
			}
		});

		// Provide some space from the top
		$(el).find('.search-results').animate({
			'scrollTop' : height - 100
		}, 200);
	}

	// Attach a listener to the search box
	function keyPress(e) {
		if (el.hasClass('disabled')) { // Ignore input when disabled.
			return;
		}
		if (e.which == 13) {
			// Enter
			if (($(el).find('.search-results .option.highlighted').length == 0) && el.data('appendable')) {
				createNewItem();
			} else {
				$(el).find('.search-results .option.highlighted').click();
			}
		} else if (e.which == 38) {
			itemHighlight("up");
		} else if (e.which == 40) {
			itemHighlight("down");
		} else {
			// All other input
			updateSearch(); // TODO: Debounce (400).
		}

	};

	$(el).on('keyup', '.search-box input', keyPress);
};

// ----- Textarea Field -----

/**
 * The core textarea object.
 */
bitte.ui.textarea = bitte.ui.textarea || {};

/**
 * Creates a new textarea.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.textarea.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'textarea';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['placeholder'] = data['placeholder'] || '';
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.textarea.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	var textarea = $('<textarea aria-labelledby="' + data['labelId'] + '" placeholder="' + data['placeholder'] + '"></textarea>');

	// Check if required.
	if (data['required']) {
		textarea.attr('aria-required', 'true');
	}

	field.append(textarea);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'textarea');
	field.data('name', data['name']);
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.textarea.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a textarea.
 */
bitte.ui.textarea.validator = function (required, messages) {
	return function (value) {
		if (required && value == '') {
			return messages['nullValue'] || 'Please enter a value.';
		} else {
			return true;
		}
	};
};

/**
 * Retrieves the data entered into the textarea.
 * @param el The textarea to retrieve the value from.
 */
bitte.ui.textarea.fetch = function (el) {
	el = $(el);

	var value = el.find('textarea').val();

	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Sets the new value for the textarea.
 * @param el The textarea.
 * @param value The value to set.
 */
bitte.ui.textarea.setValue = function (el, value) {
	el = $(el);

	if (value) {
		el.find('textarea').val(value);
	} else {
		el.find('textarea').val('');
	}
	el.trigger('ui-change');
	el.validate();
};

/**
 * Resets the textarea.
 * @param el The textarea.
 */
bitte.ui.textarea.reset = function (el) {
	el = $(el);
	el.find('textarea').val('');

	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the textarea is enabled.
 * @param el The textarea to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.textarea.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
		el.find('textarea').prop('disabled', false);
	} else {
		el.addClass('disabled');
		el.find('textarea').prop('disabled', true);
	}
};

/**
 * Attaches functionality to the textarea.
 * @param el The textarea.
 */
bitte.ui.textarea.bind = function (el) {
	el = $(el);

	el.on('change', 'textarea', function () {
		el.trigger('ui-change');
		el.validate();
	});
};

// ----- Radio -----

/**
 * The core radio object.
 */
bitte.ui.radio = bitte.ui.radio || {};

/**
 * Creates a new radio group.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.radio.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'radio';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.radio.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');

	// Generate a button group.
	var group = $('<ul aria-labelledby="' + data['labelId'] + '" class="radiogroup" role="radiogroup"></ul>');

	// Check if required.
	if (data['required']) {
		group.attr('aria-required', 'true');
	}

	// Check if disabled.
	if (data['disabled']) {
		group.attr('aria-disabled', 'true');
	}

	// Index of the radio button which will be focusable initially
	var startingIndex = 0;

	// Generate options.
	for (var i = 0; i < data['options'].length; i++) {
		var display = data['options'][i]['display'] || data['options'][i]['value'];
		var option = $('<li class="radio-container"><button type="button" class="radio" role="radio" data-value="' + data['options'][i]['value'] + '" aria-label="' + display + '">' + display + '</button></li>');

		// Add attributes.
		option.find('button').attr('aria-checked', 'false').attr('tabindex', '-1');

		// Append option.
		group.append(option);

		// If this is the specified default value, log the index
		if (data['options'][i]['value'] == data['default']) {
			startingIndex = i;
		}
	}

	// Merge all groups.
	field.append(group);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'radio');
	field.data('name', data['name']);
	field.data('validator', data['validate']);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Bind functionality to element.
	bitte.ui.radio.bind(field, startingIndex);

	// Set default value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		// field.setEnabled(false);
		bitte.ui.radio.setEnabled(el, false, startingIndex);
	} else {
		// field.setEnabled(true);
		bitte.ui.radio.setEnabled(el, true, startingIndex);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a radio group.
 */
bitte.ui.radio.validator = function (required, messages) {
	return function (value) {
		if (required && !value) {
			return messages['nullValue'] || 'Please select an option.';
		} else {
			return true;
		}
	}
};

/**
 * Retrieves the data selected for the radio group.
 * @param el The radio group to retrieve the value from.
 */
bitte.ui.radio.fetch = function (el) {
	el = $(el);

	var value = el.find('.checked');
	if (value.length > 0) {
		value = value.data('value');
	} else {
		value = null;
	}

	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Sets the new value for the radio group.
 * @param el The radio group.
 * @param value The value to set.
 */
bitte.ui.radio.setValue = function (el, value) {
	el = $(el);

	var item = el.find('button.radio[data-value="' + value + '"]');
	if (item.length > 0) { // An item was found, select it instead.
		item.click();
	} else { // No item found, remove selection.
		bitte.ui.radio.reset();
	}
};

/**
 * Resets the radio group
 * @param el The radio group.
 */
bitte.ui.radio.reset = function (el) {
	el = $(el);

	radioButtons = el.find('.radio');
	radioButtons.removeClass('checked'); // Deselect all values.
	radioButtons.attr('aria-checked', false); // Deselect all values.
	radioButtons.attr('tabindex', '-1');
	radioButtons.first().attr('tabindex', '0');

	el.trigger('ui-change');
	el.validate();

	el.trigger('reset');
};

/**
 * Sets whether or not the radio group is enabled.
 * @param el The radio group to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.radio.setEnabled = function (el, enabled, startingIndex) {
	el = $(el);

	if (enabled) {
		el.removeClass('disabled');

		// Reset tabindex
		$(el).find('.radio').attr('tabindex', '-1');
		$(el).find('.radio').eq(startingIndex).attr('tabindex', '0');
	} else {
		el.addClass('disabled');

		// Reset tabindex
		$(el).find('.radio').attr('tabindex', '-1');
	}
};

/**
 * Attaches functionality to the radio group.
 * @param el The radio group.
 */
bitte.ui.radio.bind = function (el, startingIndex) {
	el = $(el);

	var radiogroup = el.find('.radiogroup');
	var radios = radiogroup.find('.radio');
	var currentIndex = startingIndex;
	var keys = {
		enter: 13,
		space: 32,
		left: 37,
		up: 38,
		right: 39,
		down: 40
	};

	el.on('reset', function() {
		currentIndex = 0;
	});

	var stopEvent = function(event) {
		event.stopPropagation();
		event.preventDefault();
	};

	var getIndexOf = function(radio) {
		return Array.prototype.indexOf.call(radio.parentNode.children, radio);
	};

	var addFocus = function(index) {
		radios.eq(index).attr('tabindex', '0');
		radios.eq(index).focus();
		currentIndex = index;
		addCheck(index);
		el.trigger('ui-change');
	};

	var removeFocus = function(index) {
		radios.eq(index).attr('tabindex', '-1');
		removeCheck(index);
	};

	var addCheck = function(index) {
		radios.eq(index).attr('aria-checked', 'true');
		radios.eq(index).addClass('checked');
	};

	var removeCheck = function(index) {
		radios.eq(index).attr('aria-checked', 'false');
		radios.eq(index).removeClass('checked');
	};

	var switchFocus = function(index) {
		removeFocus(currentIndex);
		addFocus(index);
	};

	var focusPrevious = function() {
		if (currentIndex > 0) {
			switchFocus(currentIndex - 1);
		} else {
			switchFocus(radios.length - 1);
		}
	};

	var focusNext = function() {
		if (currentIndex < radios.length - 1) {
			switchFocus(currentIndex + 1);
		} else {
			switchFocus(0);
		}
	};

	var keydownHandler = function(event) {
		if ($(el).hasClass('disabled')) {
			return;
		}

		var key = event.which;

		switch (key) {
			case keys.enter:
				addCheck(currentIndex);
				stopEvent(event);
				break;
			case keys.space:
				addCheck(currentIndex);
				stopEvent(event);
				break;
			case keys.left:
				focusPrevious();
				stopEvent(event);
				break;
			case keys.up:
				focusPrevious();
				stopEvent(event);
				break;
			case keys.right:
				focusNext();
				stopEvent(event);
				break;
			case keys.down:
				focusNext();
				stopEvent(event);
				break;
		}
	};

	var clickHandler = function(event) {
		if ($(el).hasClass('disabled')) {
			return;
		}

		switchFocus(getIndexOf(event.target.parentNode));
	};

	var focusHandler = function(event) {
		if ($(el).hasClass('disabled')) {
			return;
		}

		$(event.target).addClass('focus');
	};

	var blurHandler = function(event) {
		if ($(el).hasClass('disabled')) {
			return;
		}

		$(event.target).removeClass('focus');
	};

	radiogroup.on('keydown', keydownHandler);

	radios.each(function() {
		$(this).on('click', clickHandler);
		$(this).on('focus', focusHandler);
		$(this).on('blur', blurHandler);
	});

};

// ----- Checkbox -----

/**
 * The core checkbox object.
 */
bitte.ui.checkbox = bitte.ui.checkbox || {};

/**
 * Creates a new checkbox group.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.checkbox.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'checkbox';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['options'] = data['options'] || [];
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.checkbox.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');

	// Generate a button group.
	var group = $('<div aria-labelledby="' + data['labelId'] + '" class="group"></div>');
	for (var i = 0; i < data['options'].length; i++) {
		var display = data['options'][i].display || data['options'][i].value;
		group.append($('<div class="checkbox-button" data-value="' + data['options'][i].value + '"><span>' + display + '</span></div>'));
	}

	// Merge all options.
	field.append(group);

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'checkbox');
	field.data('name', data['name']);
	field.data('validator', data['validate']);

	// Bind functionality to element.
	bitte.ui.checkbox.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Set initial value.
	if (typeof data['default'] != 'undefined') {
		field.setValue(data['default']);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by a checkbox field.
 */
bitte.ui.checkbox.validator = function (required, messages) {
	return function (value) {
		if (required) {
			if (value.length <= 0) {
				return messages['nullValue'] || 'Please select at least one option.';
			}
		}
		return true;
	};
};

/**
 * Retrieves the data selected within the checkbox group.
 * @param el The checkbox group to retrieve values from.
 */
bitte.ui.checkbox.fetch = function (el) {
	el = $(el);

	var values = [];
	el.find('.active').each(function () {
		values.push($(this).data('value'));
	});
	return {
		'name' : el.data('name'),
		'value' : values
	};
};

/**
 * Sets the new value for the checkbox group.
 * @param el The checkbox group.
 * @param checkboxes The array of checkboxes in the form: {name: 'my-checkbox-value', value: true}.
 */
bitte.ui.checkbox.setValue = function (el, checkboxes) {
	el = $(el);
	if (checkboxes) { // Only look for selections if values were provided, otherwise null/false/etc. clears.
		for (var index in checkboxes) {
			var checkbox = el.find('.checkbox-button[data-value="' + checkboxes[index].name + '"]');
			if (checkboxes[index].value) {
				checkbox.addClass('active');
			} else {
				checkbox.removeClass('active');
			}
		}
	} else {
		el.find('.checkbox-button').removeClass('active'); // Deselect all values.
		el.validate();
	}
	el.trigger('ui-change');
};

/**
 * Sets whether or not the checkbox group is enabled.
 * @param el The checkbox group to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.checkbox.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
	} else {
		el.addClass('disabled');
	}
};

/**
 * Attaches functionality to the checkbox group.
 * @param el The checkbox group.
 */
bitte.ui.checkbox.bind = function (el) {
	el = $(el);

	// Checkbox menu toggle.
	el.find('.group').each(function () {
		var group = $(this);
		group.on('click', '.checkbox-button', function () {
			if (el.hasClass('disabled')) { // Ignore input when disabled.
				return;
			}
			var selection = $(this);
			// Toggle active state.
			if (selection.hasClass('active')) {
				// Remove active on clicked button.
				selection.removeClass('active');
			} else {
				// Add active on clicked button.
				selection.addClass('active');
			}

			el.trigger('ui-change');
			el.validate();
		});
	});
};

// ----- File -----

/**
 * The core file object.
 */
bitte.ui.file = bitte.ui.file || {};

/**
 * Creates a new file element.
 * @param data The options to provide for this field.
 * @param el The optional element to attach this field to.
 */
bitte.ui.file.create = function (data, el) {

	// Validate and set default parameters.
	data = data || {};
	data['type'] = 'file';
	data['name'] = data['name'] || '';
	data['bonusclass'] = data['bonusclass'] || '';
	data['id'] = data['id'] || bitte.generateID();
	data['placeholder'] = data['placeholder'] || '';
	data['disabled'] = data['disabled'] || false;
	data['label'] = data['label'] || '';
	data['labelId'] = data['labelId'] || bitte.generateID();
	data['instructions'] = data['instructions'] || '';
	data['required'] = data['required'] || false;
	data['requiredText'] = data['requiredText'] || '*';
	data['messages'] = data['messages'] || {};
	data['validate'] = data['validate'] || bitte.ui.file.validator(data['required'], data['messages']);

	// Generate underlying field.
	var field = $('<div class="bitte-ui"></div>');
	field.append('<a class="button" href="javascript:void(0)"><span class="content">' + data['placeholder'] + '</span><span class="clear hide"></span></a>');
	field.append('<input aria-labelledby="' + data['labelId'] + '" type="file">');

	data['el'] = field;

	// Wrap the field.
	field = bitte.ui.wrap(data);

	// Set field data.
	field.data('type', 'file');
	field.data('name', data['name']);
	field.data('validator', data['validate']);
	field.data('placeholder', data['placeholder']);

	// Bind functionality to element.
	bitte.ui.file.bind(field);

	// Place the field in the location provided.
	el = $(el);
	if (el.length) {
		el.append(field);
	}

	// Disable field if necessary.
	if (data['disabled']) {
		field.setEnabled(false);
	}

	// Return the newly created field.
	return field;
};

/**
 * The default validation function for values provided by an file field.
 */
bitte.ui.file.validator = function (required, messages) {
	return function (value) {
		if (required) {
			if (value == null) {
				return messages['nullValue'] || 'Please select a file.';
			}
		}
		return true;
	};
};

/**
 * Retrieves the data entered into the file field.
 * @param el The file field to retrieve the value from.
 */
bitte.ui.file.fetch = function (el) {
	el = $(el);

	var value;
	if (el.find('input')[0].files.length) {
		value = el.find('input')[0].files[0];
	} else {
		value = null;
	}

	return {
		'name' : el.data('name'),
		'value' : value
	};
};

/**
 * Clears the value for the file field, this cannot be set.
 * @param el The file field.
 * @param value Ignored, the value is always cleared.
 */
bitte.ui.file.setValue = function (el, value) {
	el = $(el);
	el.find('.button .clear').addClass('hide'); // Hide the clear button.
	el.find('.button .content').text(el.data('placeholder')); // Reset the placeholder.
	el.find('input').replaceWith(el.find('input').clone()); // Clear out the file input by cloning, since it can't be set manually.
	el.trigger('ui-change');
	el.validate();
};

/**
 * Sets whether or not the file field is enabled.
 * @param el The file field to enable/disable.
 * @param enabled True to enable, false to disable.
 */
bitte.ui.file.setEnabled = function (el, enabled) {
	el = $(el);
	if (enabled) {
		el.removeClass('disabled');
		el.find('input').prop('disabled', false);
	} else {
		el.addClass('disabled');
		el.find('input').prop('disabled', true);
	}
};

/**
 * Attaches functionality to the file field.
 * @param el The file field.
 */
bitte.ui.file.bind = function (el) {
	el = $(el);

	el.find('.button').on('click', function () {
		el.find('input').trigger('click');
	});

	el.find('.button .clear').on('click', function (e) {
		e.stopPropagation();
		el.setValue(null);
	});

	el.on('change', 'input', function () {
		el.find('.button .content').text(el.find('input')[0].files[0].name); // Update the placeholder with the file name.
		el.find('.button .clear').removeClass('hide'); // Show the clear button

		el.trigger('ui-change');
		el.validate();
	});
};
